import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackAddToCalendarPressedPayload = TrackingPayload & {
    calendarType?: string;
};

export const trackAddToCalendarPressedAnalytics = (payload: TrackAddToCalendarPressedPayload) => {
    track(TrackingEvents.Registration.AddToCalendarPressed, payload);
};

export const useTrackAddToCalendarPressedAnalytics = () => {
    const { pathname } = useLocation();
    const url = useAppSelector((state) => getUrlFromPathname(state, pathname));

    return useCallback(
        ({ calendarType }: Omit<TrackAddToCalendarPressedPayload, 'pageName' | 'url'>) => {
            trackAddToCalendarPressedAnalytics({
                calendarType,
                pageName: getAmplitudePageNameFromPath(pathname),
                url,
            });
        },
        [pathname, url]
    );
};
